module.exports = __webpack_public_path__ + "img/c41.054d682d.gif";